/**
 * @generated SignedSource<<da3eab46d9d4c44f9c527e631d6d5312>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalDetailFooterTV_signal$data = {
  readonly employeeReceiverReceiptsCount: number;
  readonly id: string;
  readonly store: {
    readonly employeeCount: number;
    readonly id: string;
  };
  readonly " $fragmentType": "SignalDetailFooterTV_signal";
};
export type SignalDetailFooterTV_signal$key = {
  readonly " $data"?: SignalDetailFooterTV_signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalDetailFooterTV_signal">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalDetailFooterTV_signal",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employeeReceiverReceiptsCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employeeCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Signal",
  "abstractKey": null
};
})();

(node as any).hash = "ba7f1da03c7a2ca02bb44c752087f1bd";

export default node;
